<template>
  <!-- Add New Contracts -->
  <div class="toggle-popup">
    <div class="sidebar-layout">
      <div class="sidebar-header">
        <h4>Add New Contracts</h4>
        <a href="#" class="sidebar-close toggle-btn"><i class="ti ti-x"></i></a>
      </div>
      <div class="toggle-body">
        <div class="toggle-height">
          <div class="pro-create">
            <div class="row">
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Subject <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Date of Birth<span class="text-danger">*</span></label
                  >
                  <div class="icon-form">
                    <date-time-picker
                      v-model="startdate"
                      text-input
                      format="dd/MM/yyyy"
                      auto-apply
                      :enable-time-picker="false"
                      :disabled=false
                      :clearable=true
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >End Date<span class="text-danger">*</span></label
                  >
                  <div class="icon-form">
                    <date-time-picker
                      v-model="startdateOne"
                      text-input
                      format="dd/MM/yyyy"
                      auto-apply
                      :enable-time-picker="false"
                      :disabled=false
                      :clearable=true
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Client <span class="text-danger">*</span></label
                  >
                  <vue-select :options="MobileSel" id="mobilesel" placeholder="Choose" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Contact Value<span class="text-danger">*</span></label
                  >
                  <vue-select :options="ChoSel" id="chosel" placeholder="Choose" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Contact Value <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Attachment <span class="text-danger">*</span></label
                  >
                  <div class="drag-attach">
                    <input type="file" />
                    <div class="img-upload">
                      <i class="ti ti-file-broken"></i>Upload File
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Description <span class="text-danger">*</span></label
                  >
                  <ckeditor
                    :editor="editor"
                    v-model="editorData"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-button text-end">
            <a href="#" class="btn btn-light sidebar-close">Reset</a>
            <a
              href="#"
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#create_project"
              >Create</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add New Contracts -->

  <!-- Edit Contracts -->
  <div class="toggle-popup1">
    <div class="sidebar-layout">
      <div class="sidebar-header">
        <h4>Edit Contracts</h4>
        <a href="#" class="sidebar-close1 toggle-btn"><i class="ti ti-x"></i></a>
      </div>
      <div class="toggle-body">
        <div class="toggle-height">
          <div class="pro-create">
            <div class="row">
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Subject <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Web Design Contract"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Date of Birth<span class="text-danger">*</span></label
                  >
                  <div class="icon-form">
                    <date-time-picker
                      v-model="startdateTwo"
                      text-input
                      format="dd/MM/yyyy"
                      auto-apply
                      :enable-time-picker="false"
                      :disabled=false
                      :clearable=true
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >End Date<span class="text-danger">*</span></label
                  >
                  <div class="icon-form">
                    <date-time-picker
                      v-model="startdateThree"
                      text-input
                      format="dd/MM/yyyy"
                      auto-apply
                      :enable-time-picker="false"
                      :disabled=false
                      :clearable=true
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Client <span class="text-danger">*</span></label
                  >
                  <vue-select
                    :options="EditMobileSel"
                    id="editmobilesel"
                    placeholder="Choose"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Contact Value<span class="text-danger">*</span></label
                  >
                  <vue-select
                    :options="SeallSel"
                    id="seallsel"
                    placeholder="Contracts under Seal"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Contact Value <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" placeholder="$25,00,500" />
                </div>
              </div>
              <div class="form-wrap">
                <label class="col-form-label"
                  >Attachment <span class="text-danger">*</span></label
                >
                <div class="drag-attach">
                  <input type="file" />
                  <div class="img-upload">
                    <i class="ti ti-file-broken"></i>Upload File
                  </div>
                </div>
              </div>
              <div class="form-wrap">
                <label class="col-form-label">Uploaded Files</label>
                <div class="upload-file upload-list">
                  <div>
                    <h6>Web_Design_Contract.pdf</h6>
                    <p>1.2 MB</p>
                  </div>
                  <a href="javascript:void(0);" class="text-danger"
                    ><i class="ti ti-trash-x"></i
                  ></a>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label"
                    >Description <span class="text-danger">*</span></label
                  >
                  <ckeditor
                    :editor="editor"
                    v-model="editorData"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-button text-end">
            <a href="#" class="btn btn-light sidebar-close1">Reset</a>
            <a
              href="#"
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#create_project"
              >Create</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Contracts -->

  <!-- view Contracts -->
  <div class="toggle-popup2">
    <!-- Contract -->
    <div class="sidebar-layout">
      <div class="sidebar-header">
        <h4>Estimation<span class="badge badge-danger-light ms-2">#274738</span></h4>
        <div class="toogle-header-select d-flex align-items-center">
          <vue-select :options="SignedSel" id="signedsel" placeholder="Mark as Signed" />

          <a href="#" class="sidebar-close2 toggle-btn ms-2"><i class="ti ti-x"></i></a>
        </div>
      </div>
      <div class="toggle-body">
        <form action="#" class="toggle-height">
          <div class="pro-create">
            <div class="tab-activity">
              <ul class="nav">
                <li>
                  <a
                    href="#"
                    data-bs-toggle="tab"
                    data-bs-target="#activity"
                    class="active"
                    >Contract Details</a
                  >
                </li>
                <li>
                  <a href="#" data-bs-toggle="tab" data-bs-target="#comments"
                    >Renewal Histroy</a
                  >
                </li>
              </ul>
            </div>
            <div class="tab-content">
              <div class="tab-pane show active" id="activity">
                <div class="submit-button text-end">
                  <a href="#" class="btn btn-light sidebar-close">Download</a>
                  <a href="#" class="btn btn-primary">Sign Now</a>
                </div>
                <div class="toggle-content-view">
                  <h5>Web Design Contract</h5>
                  <p>
                    Where's the other side. The further off from England the nearer is to
                    find my way into a tree. By the use of a well--' 'What did they draw?'
                    said Alice, in a sorrowful tone, 'I'm afraid I've offended it again
                  </p>
                </div>
                <div class="card">
                  <div class="card-body">
                    <div class="details-propsal">
                      <div class="row">
                        <div class="col-lg-6 col-12">
                          <div class="proposal-to">
                            <div class="contact-type">
                              <h6>Contract Value : $25,25,000</h6>
                              <ul>
                                <li>
                                  <h5>Type</h5>
                                  <h6>Contracts under Seal</h6>
                                </li>
                                <li>
                                  <h5>Start Date</h5>
                                  <h6>24 Apr 2024</h6>
                                </li>
                                <li>
                                  <h5>End Date</h5>
                                  <h6>26 Apr 2024</h6>
                                </li>
                                <li>
                                  <h5>Client</h5>
                                  <h6>Harbor View</h6>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-12">
                          <div class="proposal-to">
                            <h3>CRMS</h3>
                            <span>3338 Marcus Street </span>
                            <span>Birmingham, AL 35211</span>
                            <span>Phone : +1 98789 78788 </span>
                            <span>Email : info@example.com</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="attached-div">
                  <h5>Attachment</h5>
                  <div class="attachement-download">
                    <div class="attachement-download-img">
                      <div class="attachement-download-icon">
                        <span><i class="ti ti-file-type-pdf"></i></span>
                      </div>
                      <div class="attachement-download-content">
                        <h5>Proposal_webdesign.pdf</h5>
                        <h6>15.2 MB</h6>
                      </div>
                    </div>
                    <div class="attachement-download-btn">
                      <a href="#"><i class="ti ti-download"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="comments">
                <div class="renewal-history">
                  <h4>Renewal History</h4>
                </div>
                <div class="renewal-content">
                  <div class="renewal-content-history">
                    <div class="contact-type">
                      <h6>Contract Value : $25,25,000</h6>
                      <ul>
                        <li>
                          <h5>Start Date</h5>
                          <h6>24 Apr 2024</h6>
                        </li>
                        <li>
                          <h5>End Date</h5>
                          <h6>24 Apr 2024</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="renewal-content-btn">
                    <a href="#" class="btn btn-primary view-popup">Renew Now</a>
                  </div>
                </div>
                <div class="renewal-content">
                  <div class="renewal-content-history">
                    <div class="contact-type">
                      <h6>Contract Value : $25,25,000</h6>
                      <ul>
                        <li>
                          <h5>Start Date</h5>
                          <h6>24 Apr 2024</h6>
                        </li>
                        <li>
                          <h5>End Date</h5>
                          <h6>24 Apr 2024</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="renewal-content-btn">
                    <span class="badge badge-danger-light">Renewed On : 24 Apr 2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Contract -->
  </div>
  <!-- /view Contracts -->

  <!-- Delete Contracts -->
  <div class="modal custom-modal fade" id="delete_contracts" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-message text-center">
            <div class="success-popup-icon">
              <i class="ti ti-trash-x"></i>
            </div>
            <h3>Remove Contracts?</h3>
            <p class="del-info">
              Are you sure you want to remove contracts you selected.
            </p>
            <div class="col-lg-12 text-center modal-btn">
              <a href="#" class="btn btn-light" data-bs-dismiss="modal">Cancel</a>
              <router-link to="/crm/contracts-list" class="btn btn-danger"
                >Yes, Delete it</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Contracts -->

  <!-- Create Contracts -->
  <div class="modal custom-modal fade" id="create_project" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-message text-center">
            <div class="success-popup-icon bg-light-blue">
              <i class="ti ti-atom-2"></i>
            </div>
            <h3>Contracts Created Successfully!!!</h3>
            <p>View the details of contracts, created</p>
            <div class="col-lg-12 text-center modal-btn">
              <a href="#" class="btn btn-light" data-bs-dismiss="modal">Cancel</a>
              <a href="#" class="btn btn-primary">View Details</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Create Contracts -->

  <!-- Add New View -->
  <div class="modal custom-modal fade" id="save_view" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add New View</h5>
          <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <form action="/crm/contracts-list">
            <div class="form-wrap">
              <label class="col-form-label">View Name</label>
              <input type="text" class="form-control" />
            </div>
            <div class="modal-btn text-end">
              <a href="#" class="btn btn-light" data-bs-dismiss="modal">Cancel</a>
              <button type="submit" class="btn btn-danger">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add New View -->

  <div class="toggle-popups">
    <div class="sidebar-layout">
      <div class="sidebar-header">
        <h4>Renew Contract</h4>
        <a href="#" class="sidebar-close-view toggle-btn"><i class="ti ti-x"></i></a>
      </div>
      <div class="toggle-body">
        <form action="contracts-list" class="toggle-height">
          <div class="pro-create">
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label"
                  >Start Date<span class="text-danger">*</span></label
                >
                <div class="icon-form">
                  <date-time-picker
                    v-model="startdateFour"
                    text-input
                    format="dd/MM/yyyy"
                    auto-apply
                    :enable-time-picker="false"
                    :disabled=false
                    :clearable=true
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label"
                  >End Date<span class="text-danger">*</span></label
                >
                <div class="icon-form">
                  <date-time-picker
                    v-model="startdateFive"
                    text-input
                    format="dd/MM/yyyy"
                    auto-apply
                    :enable-time-picker="false"
                    :disabled=false
                    :clearable=true
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label"
                  >Client<span class="text-danger">*</span></label
                >
                <vue-select :options="ViewSel" id="viewsel" placeholder="Harbor View" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Contract Type</label>
                <vue-select
                  :options="ContractsSel"
                  id="contractssel"
                  placeholder="Contracts under Seal"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label"
                  >Contact Value<span class="text-danger">*</span></label
                >
                <input type="text" class="form-control" placeholder="$25,00,500" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label"
                  >Attachment <span class="text-danger">*</span></label
                >
                <div class="drag-attach">
                  <input type="file" />
                  <div class="img-upload">
                    <i class="ti ti-file-broken"></i>Upload File
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Uploaded Files</label>
                <div class="upload-file upload-list">
                  <div>
                    <h6>tes.txt</h6>
                    <p>4.25 MB</p>
                  </div>
                  <a href="javascript:void(0);" class="text-danger"
                    ><i class="ti ti-trash-x"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-button text-end">
            <a href="#" class="btn btn-light sidebar-close2">Cancel</a>
            <button type="submit" class="btn btn-primary">Create</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());
const currentDateThree = ref(new Date());
const currentDateFour = ref(new Date());
const currentDateFive = ref(new Date());
export default {
  data() {
    return {
      editor: ClassicEditor,
      editorData: "Description",
      editorConfig: {},
      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      startdateThree: currentDateThree,
      startdateFour: currentDateFour,
      startdateFive: currentDateFive,
      dateFormat: "dd/MM/yyyy",
      MobileSel: ["Choose", "Mobile App", "Meeting"],
      EditMobileSel: ["Choose", "Mobile App", "Meeting"],
      ChoSel: ["Choose", "Mobile App", "Meeting"],
      SeallSel: ["Contract under Seal", "Meeting"],
      ViewSel: ["Harbor View", "CoastalStar Co.", "RiverStone Ventur"],
      ContractsSel: ["Contracts under Seal", "COntract", "RiverStone Ventur"],
      SignedSel: [
        "Mark as Signed",
        "View PDF",
        "Download",
        "Mark as Signed",
        "Clone",
        "Edit",
        "Print",
      ],
    };
  },
  mounted() {
    if (document.getElementsByClassName("add-popup").length > 0) {
      var addPopups = document.getElementsByClassName("add-popup");
      for (var i = 0; i < addPopups.length; i++) {
        addPopups[i].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup")[0];
          if (togglePopup) {
            togglePopup.classList.add("sidebar-popup");
          }
        });
      }

      var sidebarCloses = document.getElementsByClassName("sidebar-close");
      for (var j = 0; j < sidebarCloses.length; j++) {
        sidebarCloses[j].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup")[0];
          if (togglePopup) {
            togglePopup.classList.remove("sidebar-popup");
          }
        });
      }
    }
    if (document.getElementsByClassName("add-popups").length > 0) {
      var addPopupsOne = document.getElementsByClassName("add-popups");
      for (var k = 0; k < addPopupsOne.length; k++) {
        addPopupsOne[k].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup2")[0];
          if (togglePopup) {
            togglePopup.classList.add("sidebar-popup");
          }
        });
      }

      var sidebarClosesOne = document.getElementsByClassName("sidebar-close2");
      for (var l = 0; l < sidebarClosesOne.length; l++) {
        sidebarClosesOne[l].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup2")[0];
          if (togglePopup) {
            togglePopup.classList.remove("sidebar-popup");
          }
        });
      }
    }
    if (document.getElementsByClassName("edit-popup").length > 0) {
      var addPopupsTwo = document.getElementsByClassName("edit-popup");
      for (var m = 0; m < addPopupsTwo.length; m++) {
        addPopupsTwo[m].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup1")[0];
          if (togglePopup) {
            togglePopup.classList.add("sidebar-popup");
          }
        });
      }

      var sidebarClosesTwo = document.getElementsByClassName("sidebar-close1");
      for (var n = 0; n < sidebarClosesTwo.length; n++) {
        sidebarClosesTwo[n].addEventListener("click", () => {
          var togglePopup = document.getElementsByClassName("toggle-popup1")[0];
          if (togglePopup) {
            togglePopup.classList.remove("sidebar-popup");
          }
        });
      }
    }
  },
};
</script>
